export const MetricsSection = () => {
  return (
    <section className="py-24 px-6 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center gap-3 justify-center mb-4">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-bar-chart-box-line text-gray-500 text-xl"></i>
            </div>
            <span className="text-gray-500 text-sm tracking-[0.3em] uppercase">Métricas</span>
          </div>
          <h2 className="text-5xl font-bold text-white mb-4">
            Tu Recepción te dice qué pasó ayer.
          </h2>
          <p className="text-xl max-w-2xl mx-auto bg-gradient-to-r from-cyan-400 to-pink-500 bg-clip-text text-transparent font-semibold">
            Mina te dice cuánto ganarás mañana.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* MÓDULO A // CASH FLOW */}
          <div className="bg-[#0d1117] rounded-2xl p-6 border border-gray-800/50 hover:border-cyan-500/30 transition-all">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-gray-600 text-xs tracking-[0.2em] uppercase mb-1">Módulo A //</p>
                <h3 className="text-white font-bold tracking-wide">CASH FLOW</h3>
              </div>
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-500/20 to-green-600/10 flex items-center justify-center">
                <i className="ri-money-dollar-circle-line text-green-400 text-xl"></i>
              </div>
            </div>
            
            <div className="mb-4">
              <p className="text-gray-500 text-xs uppercase tracking-wider mb-2">Ingresos Atribuidos</p>
              <div className="flex items-baseline gap-3">
                <span className="text-5xl font-light text-white tracking-tight">124€</span>
                <span className="text-cyan-400 text-sm">+14% vs feb</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-6">
              <div className="bg-[#111827] rounded-xl p-4 border border-gray-800/30">
                <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">Recuperado</p>
                <p className="text-white text-xl font-semibold">9€</p>
              </div>
              <div className="bg-[#111827] rounded-xl p-4 border border-gray-800/30">
                <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">Upsell AI</p>
                <p className="text-white text-xl font-semibold">5€</p>
              </div>
            </div>
          </div>

          {/* MÓDULO D // STAFF */}
          <div className="bg-[#0d1117] rounded-2xl p-6 border border-gray-800/50 hover:border-cyan-500/30 transition-all">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-gray-600 text-xs tracking-[0.2em] uppercase mb-1">Módulo D //</p>
                <h3 className="text-white font-bold tracking-wide">STAFF</h3>
              </div>
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500/20 to-amber-600/10 flex items-center justify-center">
                <i className="ri-user-star-line text-amber-400 text-xl"></i>
              </div>
            </div>

            <div className="space-y-3 mb-6">
              <div className="bg-gradient-to-r from-cyan-500/10 to-teal-500/10 border border-cyan-500/20 rounded-xl p-4 flex items-center gap-4">
                <div className="w-8 h-8 rounded-lg bg-cyan-500/20 flex items-center justify-center">
                  <span className="text-sm font-bold text-cyan-400">1º</span>
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-white">DRA. LAURA</p>
                </div>
                <div className="text-right">
                  <span className="text-sm text-cyan-400">40%</span>
                  <span className="text-gray-500 text-xs ml-1">solicitudes</span>
                </div>
              </div>
              
              <div className="bg-[#111827] border border-gray-800/30 rounded-xl p-4 flex items-center gap-4">
                <div className="w-8 h-8 rounded-lg bg-gray-700/50 flex items-center justify-center">
                  <span className="text-sm font-bold text-gray-400">2º</span>
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-gray-300">MARÍA</p>
                </div>
                <div className="text-right">
                  <span className="text-sm text-gray-400">22%</span>
                  <span className="text-gray-500 text-xs ml-1">solicitudes</span>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-800/50 pt-4">
              <p className="text-gray-500 text-xs uppercase tracking-wider mb-3">Análisis de Sentimiento</p>
              <div className="flex items-center justify-between">
                <p className="text-cyan-400 italic">"María fue encantadora"</p>
                <div className="flex items-center gap-2">
                  <span className="text-gray-500 text-xs">POSS.</span>
                  <span className="text-green-400 font-semibold">88%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MÓDULO C // PIPELINE */}
        <div className="flex justify-center mt-6">
          <div className="w-full lg:w-[calc(50%-0.75rem)] bg-[#0d1117] rounded-2xl p-6 border border-gray-800/50 hover:border-cyan-500/30 transition-all">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-gray-600 text-xs tracking-[0.2em] uppercase mb-1">Módulo C //</p>
                <h3 className="text-white font-bold tracking-wide">PIPELINE</h3>
              </div>
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500/20 to-orange-600/10 flex items-center justify-center">
                <i className="ri-settings-3-line text-orange-400 text-xl"></i>
              </div>
            </div>

            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 rounded-lg bg-cyan-500/10 flex items-center justify-center">
                <i className="ri-star-line text-cyan-400 text-lg"></i>
              </div>
              <div>
                <p className="text-gray-500 text-[10px] uppercase tracking-widest">Top Servicio</p>
                <p className="text-white font-semibold text-sm">Masaje relajante</p>
              </div>
            </div>

            <div className="rounded-xl border border-red-500/30 bg-gradient-to-r from-red-500/10 to-orange-500/5 p-4 mb-6">
              <p className="text-orange-400 text-[10px] font-bold uppercase tracking-widest mb-2">Alerta de Conversión</p>
              <p className="text-gray-300 text-sm leading-relaxed">
                "Hemos perdido 3 citas por falta de huecos.<br />Sugiero abrir agenda de tarde."
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="text-center">
                <p className="text-white text-4xl font-light tracking-tight">35</p>
                <p className="text-gray-500 text-[10px] uppercase tracking-widest mt-1">Citas Nocturnas</p>
              </div>
              <div className="text-center">
                <p className="text-white text-4xl font-light tracking-tight">67%</p>
                <p className="text-gray-500 text-[10px] uppercase tracking-widest mt-1">Tasa Conv.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};